/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListMeta
 */
export interface ListMeta {
    /**
     * Amount of items in the system
     * @type {number}
     * @memberof ListMeta
     */
    total: number;
    /**
     * Displayed page
     * @type {number}
     * @memberof ListMeta
     */
    page: number;
    /**
     * Elements displayed per page
     * @type {number}
     * @memberof ListMeta
     */
    pageSize?: number | null;
}

/**
 * Check if a given object implements the ListMeta interface.
 */
export function instanceOfListMeta(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function ListMetaFromJSON(json: any): ListMeta {
    return ListMetaFromJSONTyped(json, false);
}

export function ListMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'page': json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
    };
}

export function ListMetaToJSON(value?: ListMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'page': value.page,
        'pageSize': value.pageSize,
    };
}

